/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { APIBlankEnum } from './APIBlankEnum';
import {
    instanceOfAPIBlankEnum,
    APIBlankEnumFromJSON,
    APIBlankEnumFromJSONTyped,
    APIBlankEnumToJSON,
} from './APIBlankEnum';
import type { APIFileTypeEnum } from './APIFileTypeEnum';
import {
    instanceOfAPIFileTypeEnum,
    APIFileTypeEnumFromJSON,
    APIFileTypeEnumFromJSONTyped,
    APIFileTypeEnumToJSON,
} from './APIFileTypeEnum';

/**
 * @type APIGuestRequestFileFileType
 * 
 * @export
 */
export type APIGuestRequestFileFileType = APIBlankEnum | APIFileTypeEnum;

export function APIGuestRequestFileFileTypeFromJSON(json: any): APIGuestRequestFileFileType {
    return APIGuestRequestFileFileTypeFromJSONTyped(json, false);
}

export function APIGuestRequestFileFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestFileFileType {
    if (json == null) {
        return json;
    }
    if (instanceOfAPIBlankEnum(json)) {
        return APIBlankEnumFromJSONTyped(json, true);
    }
    if (instanceOfAPIFileTypeEnum(json)) {
        return APIFileTypeEnumFromJSONTyped(json, true);
    }

    return {} as any;
}

export function APIGuestRequestFileFileTypeToJSON(value?: APIGuestRequestFileFileType | null): any {
    if (value == null) {
        return value;
    }

    if (instanceOfAPIBlankEnum(value)) {
        return APIBlankEnumToJSON(value as APIBlankEnum);
    }
    if (instanceOfAPIFileTypeEnum(value)) {
        return APIFileTypeEnumToJSON(value as APIFileTypeEnum);
    }

    return {};
}

